import type { ReactElement } from "react";

import { AnchorButton } from "@rootreeweb/ui";

import type { WallpaperGridProps } from "./WallpaperGrid.js";
import { WallpaperGrid } from "./WallpaperGrid.js";

type WallpaperCardProps = {
	items: WallpaperGridProps["items"];
	language: "EN" | "FR";
	links: {
		allDesktop: string;
		allMobile: string;
	};
};

/**
 * Content for the Wallpaper Downloads card.
 *
 * @param props - The props for the Wallpaper Downloads card.
 * @returns The content for the Wallpaper Downloads card.
 */
export function WallPaperCard(props: WallpaperCardProps): ReactElement {
	const { items, language, links } = props;
	return (
		<>
			<div className="hl:flex hl:flex-col hl:justify-center hl:gap-4 hl:first:mb-8 hl:lg:flex-row">
				<AnchorButton
					className={"hl:no-underline"}
					colour={"white"}
					download
					href={links.allDesktop}
					target="_blank"
				>
					{language === "FR"
						? "Tous les fonds d'écran pour bureaux d'ordinateur"
						: "All Desktop"}
				</AnchorButton>
				<AnchorButton
					className={"hl:no-underline"}
					colour={"white"}
					download
					href={links.allMobile}
					target="_blank"
				>
					{language === "FR"
						? "Tous les fonds d'écran pour téléphones portables en"
						: "All Mobile"}
				</AnchorButton>
			</div>
			<WallpaperGrid items={items} language={language} />
		</>
	);
}
